import { GridColDef } from '@mui/x-data-grid';
import { IPostgreJobsAnalyticsPayload, ICandidateFilter } from 'wisestep-api';

import { ClientNotesWidget } from '../../../DerivedCharts/helper';
import { renderCellFor } from '../../helper';
import { IClientNotesDTO } from '../../jobs/types/postgreJobsDTO';

import { renderClientNotesCountCell } from './clientNotesDrillDownHelper';

export const getClientNotesColumns = (
  widgetName: ClientNotesWidget,
  widgetData: IClientNotesDTO,
  query: IPostgreJobsAnalyticsPayload,
  analyticsFilter: ICandidateFilter[]
): GridColDef[] => {
  switch (widgetName) {
    case ClientNotesWidget.TABLE_CLIENT:
      return [
        {
          field: 'clientName',
          headerName: 'Client Name',
          flex: 2,
          renderCell: (params) => renderCellFor('CLIENT', params),
        },
        {
          field: 'count',
          headerName: `Total Count (${widgetData.totalCount})`,
          flex: 1,
          renderCell: (params) =>
            renderClientNotesCountCell(
              params,
              [['CLIENT_ID', params.row.clientId]],
              analyticsFilter,
              query
            ),
        },
      ];
    case ClientNotesWidget.TABLE_CLIENT_SPOC:
      return [
        {
          field: 'clientContactName',
          headerName: 'Client Spoc',
          flex: 2,
          renderCell: (params) => renderCellFor('CLIENT_RECRUITER', params),
        },
        {
          field: 'clientName',
          headerName: 'Client Name',
          flex: 2,
          renderCell: (params) => renderCellFor('CLIENT', params),
        },
        {
          field: 'count',
          headerName: `Total Count (${widgetData.totalCount})`,
          flex: 2,
          renderCell: (params) =>
            renderClientNotesCountCell(
              params,
              [
                ['CLIENT_CONTACT_ID', params.row.clientContactId],
                ['CLIENT_ID', params.row.clientId],
              ],
              analyticsFilter,
              query
            ),
        },
      ];
    case ClientNotesWidget.TABLE_RECRUITER_CLIENT:
      return [
        {
          field: 'recruiterName',
          headerName: 'User Name',
          flex: 2,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        {
          field: 'clientName',
          headerName: 'Client Name',
          flex: 2,
          renderCell: (params) => renderCellFor('CLIENT', params),
        },
        {
          field: 'count',
          headerName: `Total Count (${widgetData.totalCount})`,
          flex: 1,
          renderCell: (params) =>
            renderClientNotesCountCell(
              params,
              [
                ['RECRUITER_ID', params.row.recruiterEmail],
                ['CLIENT_ID', params.row.clientId],
              ],
              analyticsFilter,
              query
            ),
        },
      ];
    case ClientNotesWidget.TABLE_RECRUITER_CLIENT_SPOC:
      return [
        {
          field: 'recruiterName',
          headerName: 'User Name',
          flex: 1.5,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        {
          field: 'clientContactName',
          headerName: 'Client Spoc',
          flex: 1.5,
          renderCell: (params) => renderCellFor('CLIENT_RECRUITER', params),
        },
        {
          field: 'clientName',
          headerName: 'Client Name',
          flex: 1,
          renderCell: (params) => renderCellFor('CLIENT', params),
        },
        {
          field: 'count',
          headerName: `Total Count (${widgetData.totalCount})`,
          flex: 1,
          renderCell: (params) =>
            renderClientNotesCountCell(
              params,
              [
                ['RECRUITER_ID', params.row.recruiterEmail],
                ['CLIENT_ID', params.row.clientId],
                ['CLIENT_CONTACT_ID', params.row.clientContactId],
              ],
              analyticsFilter,
              query
            ),
        },
      ];
    case ClientNotesWidget.TABLE_TYPEWISE_CLIENT:
      return [
        {
          field: 'clientName',
          headerName: 'Client Name',
          flex: 2,
          renderCell: (params) => renderCellFor('CLIENT', params),
        },
        {
          field: 'count',
          headerName: `Total (${widgetData.totalCount})`,
          flex: 1,
          renderCell: (params) =>
            renderClientNotesCountCell(
              params,
              [['CLIENT_ID', params.row.clientId]],
              analyticsFilter,
              query
            ),
        },
        {
          field: 'phone',
          headerName: `Phone (${widgetData.totalCountByType?.['totalSMSNotes']})`,
          flex: 1,
          renderCell: (params) =>
            renderClientNotesCountCell(
              params,
              [
                ['CLIENT_ID', params.row.clientId],
                ['NOTE_TYPE', 'Phone'],
              ],
              analyticsFilter,
              query
            ),
        },
        {
          field: 'email',
          headerName: `Email (${widgetData.totalCountByType?.['totalEmailNotes']})`,
          flex: 1,
          renderCell: (params) =>
            renderClientNotesCountCell(
              params,
              [
                ['CLIENT_ID', params.row.clientId],
                ['NOTE_TYPE', 'Email'],
              ],
              analyticsFilter,
              query
            ),
        },
        {
          field: 'sms',
          headerName: `SMS (${widgetData.totalCountByType?.['totalSMSNotes']})`,
          flex: 1,
          renderCell: (params) =>
            renderClientNotesCountCell(
              params,
              [
                ['CLIENT_ID', params.row.clientId],
                ['NOTE_TYPE', 'SMS'],
              ],
              analyticsFilter,
              query
            ),
        },
        {
          field: 'other',
          headerName: `Other (${widgetData.totalCountByType?.['totalOtherNotes']})`,
          flex: 1,
          renderCell: (params) =>
            renderClientNotesCountCell(
              params,
              [
                ['CLIENT_ID', params.row.clientId],
                ['NOTE_TYPE', 'Other'],
              ],
              analyticsFilter,
              query
            ),
        },
      ];
    case ClientNotesWidget.TABLE_TYPEWISE_CLIENT_SPOC:
      return [
        {
          field: 'clientContactName',
          headerName: 'Client Spoc',
          flex: 2,
          renderCell: (params) => renderCellFor('CLIENT_RECRUITER', params),
        },
        {
          field: 'clientName',
          headerName: 'Client Name',
          flex: 2,
          renderCell: (params) => renderCellFor('CLIENT', params),
        },
        {
          field: 'count',
          headerName: `Total (${widgetData.totalCount})`,
          flex: 1,
          renderCell: (params) =>
            renderClientNotesCountCell(
              params,
              [
                ['CLIENT_ID', params.row.clientId],
                ['CLIENT_CONTACT_ID', params.row.clientContactId],
              ],
              analyticsFilter,
              query
            ),
        },
        {
          field: 'phone',
          headerName: `Phone (${widgetData.totalCountByType?.['totalSMSNotes']})`,
          flex: 1,
          renderCell: (params) =>
            renderClientNotesCountCell(
              params,
              [
                ['CLIENT_ID', params.row.clientId],
                ['CLIENT_CONTACT_ID', params.row.clientContactId],
                ['NOTE_TYPE', 'Phone'],
              ],
              analyticsFilter,
              query
            ),
        },
        {
          field: 'email',
          headerName: `Email (${widgetData.totalCountByType?.['totalEmailNotes']})`,
          flex: 1,
          renderCell: (params) =>
            renderClientNotesCountCell(
              params,
              [
                ['CLIENT_ID', params.row.clientId],
                ['CLIENT_CONTACT_ID', params.row.clientContactId],
                ['NOTE_TYPE', 'Email'],
              ],
              analyticsFilter,
              query
            ),
        },
        {
          field: 'sms',
          headerName: `SMS (${widgetData.totalCountByType?.['totalSMSNotes']})`,
          flex: 1,
          renderCell: (params) =>
            renderClientNotesCountCell(
              params,
              [
                ['CLIENT_ID', params.row.clientId],
                ['CLIENT_CONTACT_ID', params.row.clientContactId],
                ['NOTE_TYPE', 'SMS'],
              ],
              analyticsFilter,
              query
            ),
        },
        {
          field: 'other',
          headerName: `Other (${widgetData.totalCountByType?.['totalOtherNotes']})`,
          flex: 1,
          renderCell: (params) =>
            renderClientNotesCountCell(
              params,
              [
                ['CLIENT_ID', params.row.clientId],
                ['CLIENT_CONTACT_ID', params.row.clientContactId],
                ['NOTE_TYPE', 'Other'],
              ],
              analyticsFilter,
              query
            ),
        },
      ];
    default:
      throw new Error("Invalid 'ClientNotesWidget' type");
  }
};

export const defaultClientNotesWidgetData: IClientNotesDTO = {
  count: 0,
  totalCount: 0,
  totalCountByType: {},
  countByType: {},
  resultSet: [],
  series: [],
  categories: [],
};
